import { Component, OnDestroy, Inject, ViewChild, ElementRef, ViewEncapsulation } from '@angular/core';
import { Utilities } from '../../services/Utilities';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend'
import { Library } from '../../services/ShelvableBackend/Library'
import { StateService, StateParams } from '@uirouter/angular';
import swal from 'sweetalert';

import { FirebaseObjectObservable } from 'angularfire2/database';

import { Observable, BehaviorSubject } from 'rxjs';

@Component({
    selector: 'user-library',
    templateUrl: './user-library.html',
    styleUrls: ['./user-library.css', './user-library.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class UserLibraryComponent implements OnDestroy {
    openShelves:{[shelfName:string]: boolean} = {};
    makeArrayOfLength:(number) => any[] = Utilities.makeArrayOfLength;
    gettingStartedStages:any;
    profilePictureUrl:string;

    isLoggedIn:Observable<boolean>;
    loggedInUsername:Observable<string>;

    user:string;

    userData:FirebaseObjectObservable<any>;
    library:Library;

    @ViewChild('newShelf') newShelf:ElementRef;

    newShelfName:BehaviorSubject<string> = new BehaviorSubject<string>(null);
    shelfNameValidity = this.newShelfName.flatMap((name) => name ? this.shelvableBackend.validateShelfName(name, false) : Observable.of(null)).shareReplay(1);

    async addShelf() {
        var newName:string = await this.newShelfName.take(1).toPromise();
        if (!newName) return;

        var validity = await this.shelvableBackend.validateShelfName(newName, false);
        if (!validity || !validity.isValid) return;
        
        this.shelvableBackend.addShelf(newName);

        this.shelvableBackend.gettingStartedStages.maybeProgress('newShelf', 'shelfHeader');

        this.newShelfName.next('');

        this.newShelf.nativeElement.blur();
    };

    getBookKey = (index, book) => book.$key;

    ngOnDestroy() {
        if (this.userData) {
            this.userData = null;
        }
    }

    removeAtKey(shelf_name, books_array, book) {
        swal({
            title: 'Are you sure you want to remove this book from  "' + shelf_name + '"?',
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, remove it.",
            cancelButtonText: "No, leave it.",
            closeOnConfirm: true,
            closeOnCancel: true,
            imageUrl: "//books.google.com/books/content?id=" + book.googleId + "&printsec=frontcover&img=1&zoom=1&source=gbs_api"
        }, (isConfirmed) => {
            if (isConfirmed) {
                books_array.deleteBook(book);
            }
        });
    };

    isAnchorClick($event) {
        return $event.target.tagName.toUpperCase() == 'A';
    }

    shelfHoverDetails:{[shelfName:string] : {hoverCount:number, timeoutHandle?:number}} = {};
    shelfDragEnter(shelfName:string) {
        if (!this.shelfHoverDetails[shelfName]) {
            this.shelfHoverDetails[shelfName] = {hoverCount: 0}
        }
        this.shelfHoverDetails[shelfName].hoverCount++;
        if (!this.shelfHoverDetails[shelfName].timeoutHandle) {
            this.shelfHoverDetails[shelfName].timeoutHandle = setTimeout(() => {
                this.shelfHoverDetails[shelfName].timeoutHandle = null;
                this.openShelves[shelfName] = true;
            }, 500);
        }
    };

    shelfDragLeave(shelfName:string) {
        this.shelfHoverDetails[shelfName].hoverCount--;
        if (this.shelfHoverDetails[shelfName].hoverCount === 0) {
            clearTimeout(this.shelfHoverDetails[shelfName].timeoutHandle);
        }
    };

    constructor(@Inject("userId") public userId:string, private shelvableBackend:ShelvableBackend, stateService:StateService) {
        this.gettingStartedStages = shelvableBackend.gettingStartedStages;
        
        this.user = stateService.params.username;

        this.loggedInUsername = shelvableBackend.loggedInUserObs.usernameObs;
        
        if (userId) {
            this.userData = shelvableBackend.getUserData(userId);
            this.getProfilePictureUrl();
            this.library = shelvableBackend.getLibrary(userId);
        }
    }

    async getProfilePictureUrl() {
        var userData = await this.userData.take(1).toPromise()
        this.profilePictureUrl = this.shelvableBackend.getProfilePictureUrl(this.userId, userData.profilePictureLastChanged);
    }
}


// WEBPACK FOOTER //
// ./web/static/components/user-library/user-library.ts